// src/components/profile/RecentlyViewedProfiles.tsx
"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import type { ProfileData } from "@/types/profile";

const RECENTLY_VIEWED_KEY = "zamzi-recently-viewed-profiles";
const MAX_RECENT = 3;

export function addRecentlyViewedProfile(profile: { userId: string; name: string; slug?: string; imageUrl?: string }) {
  if (typeof window === "undefined") return;
  try {
    const existing = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || "[]");
    const filtered = existing.filter((p: any) => p.userId !== profile.userId);
    const updated = [profile, ...filtered].slice(0, MAX_RECENT);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(updated));
  } catch {}
}

export function useRecentlyViewedProfiles(): Array<{ userId: string; name: string; slug?: string; imageUrl?: string }> {
  const [recent, setRecent] = useState<Array<{ userId: string; name: string; slug?: string; imageUrl?: string }>>([]);
  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || "[]");
      setRecent(Array.isArray(stored) ? stored : []);
    } catch {
      setRecent([]);
    }
  }, []);
  return recent;
}

export function RecentlyViewedProfilesBlock() {
  const recent = useRecentlyViewedProfiles();
  if (!recent.length) return null;
  return (
    <div className="mb-6 p-4 rounded-lg border bg-muted/30">
      <h3 className="text-sm font-semibold mb-2 text-primary">Still interested?</h3>
      <div className="flex gap-3 flex-wrap">
        {recent.map((p) => (
          // A profile slug is NOT a /profile/{id} path segment — `profileType` is keyed by
          // userId. The short URL lives at /p/{slug}, so link there when only the slug is
          // known, otherwise this produced a dead 404 link.
          <Link key={p.userId} href={p.slug ? `/p/${p.slug}` : `/profile/${p.userId}`}
            className="flex items-center gap-2 px-3 py-2 rounded-md bg-white border hover:shadow-sm transition">
            {p.imageUrl && <img src={p.imageUrl} alt={p.name} className="w-8 h-8 rounded-full object-cover" />}
            <span className="text-xs font-medium">{p.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
